// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"71b13e5f","94":"f53c52ba","197":"47ee3353","583":"80d5904c"}[chunkId] + ".chunk.css";
};